var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10, _path11, _path12, _path13, _rect2, _path14, _path15, _rect3, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCementBagBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 478,
    height: 314,
    viewBox: "0 0 478 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435 83.5V132L433 134.5V80.4877L435 83.5Z",
    fill: "#8A6845"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M435 110.262V114L298 34.7744V31L435 110.262Z",
    fill: "#6B492B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.074 234.321V289.628L57 210.177V155L194.074 234.321Z",
    fill: "#8A6845"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194.074 265.594V269.343L57 189.892V186.107L194.074 265.594Z",
    fill: "#6B492B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M295.5 0.5C267 3 70.5 135.5 57 155V168.5C68.7907 175.264 119.73 202.05 194 244V234.5C290 166.1 392.667 97.8333 433 80.5C423.5 74.5 425.1 75.3 295.5 0.5Z",
    fill: "url(#paint0_linear_3764_8996)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194 289.5V234.5C265.032 178.647 381.5 100 433 80.5V134.5L194 289.5Z",
    fill: "url(#paint1_linear_3764_8996)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M230.701 246.916C232.502 243.635 233.503 239.976 233.621 236.236C233.621 232.856 232.621 230.236 230.741 228.906C228.861 227.576 226.371 227.726 223.741 229.256L206.001 241.606V250.066L223.701 237.746C224.083 237.511 224.515 237.371 224.961 237.336C225.342 237.31 225.72 237.416 226.031 237.636C226.36 237.893 226.606 238.241 226.741 238.636C226.91 239.111 226.991 239.612 226.981 240.116C226.939 241.369 226.596 242.593 225.981 243.686C225.448 244.743 224.644 245.64 223.651 246.286L219.131 249.926V258.396L223.651 254.756C226.663 252.823 229.098 250.115 230.701 246.916Z",
    fill: "#252525"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206.001 256.566V272.416C205.987 273.043 206.092 273.668 206.311 274.256C206.481 274.734 206.791 275.149 207.201 275.446C207.59 275.716 208.059 275.846 208.531 275.816C209.089 275.77 209.627 275.592 210.101 275.296L212.561 272.856V251.726L206.001 256.566Z",
    fill: "#252525"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 139.034,
    y: 150.956,
    width: 108,
    height: 43,
    rx: 4,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.975 178.956H161.945V173.718H167.129V178.956H170.117V165.654H167.129V170.856H161.945V165.654H158.975V178.956ZM172.932 178.956H182.202V176.184H175.92V173.646H181.752V170.892H175.92V168.426H182.22V165.654H172.932V178.956ZM184.586 165.654V178.956H187.574V165.654H184.586ZM196.651 179.154C199.009 179.154 201.097 178.182 202.717 176.562V170.964H196.633V173.52H200.017V175.05C199.315 175.734 198.055 176.31 196.705 176.31C194.293 176.31 192.709 174.492 192.709 172.278C192.709 170.01 194.383 168.282 196.723 168.282C198.055 168.282 199.261 168.822 200.143 169.65L202.051 167.49C200.899 166.32 198.973 165.42 196.741 165.42C192.781 165.42 189.667 168.264 189.667 172.314C189.667 176.256 192.565 179.154 196.651 179.154ZM204.941 178.956H207.911V173.718H213.095V178.956H216.083V165.654H213.095V170.856H207.911V165.654H204.941V178.956ZM221.508 168.516V178.956H224.496V168.516H228.24V165.654H217.746V168.516H221.508Z",
    fill: "#41B6E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M193.034 204.148L180.159 193.956L205.91 193.956L193.034 204.148Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8175 222.822C40.0174 223.037 39.5432 223.86 39.7582 224.66L43.2621 237.697C43.4771 238.497 44.2999 238.972 45.1 238.757C45.9 238.542 46.3743 237.719 46.1593 236.919L43.0447 225.33L54.6335 222.215C55.4335 222 55.9078 221.177 55.6927 220.377C55.4777 219.577 54.6549 219.103 53.8548 219.318L40.8175 222.822ZM193.293 311.925L192.544 313.225L193.338 313.682L194.107 313.185L193.293 311.925ZM477.674 129.418C477.848 128.608 477.332 127.81 476.522 127.636L463.324 124.8C462.514 124.626 461.716 125.141 461.542 125.951C461.368 126.761 461.883 127.559 462.693 127.733L474.426 130.254L471.904 141.986C471.73 142.796 472.246 143.594 473.055 143.768C473.865 143.942 474.663 143.426 474.837 142.617L477.674 129.418ZM40.4578 225.57L192.544 313.225L194.042 310.625L41.9558 222.971L40.4578 225.57ZM194.107 313.185L477.021 130.363L475.393 127.843L192.479 310.665L194.107 313.185Z",
    fill: "#41B6E6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M194.353 210.471C193.767 209.885 192.817 209.885 192.232 210.471L182.686 220.017C182.1 220.603 182.1 221.553 182.686 222.138C183.271 222.724 184.221 222.724 184.807 222.138L193.292 213.653L201.778 222.138C202.363 222.724 203.313 222.724 203.899 222.138C204.485 221.553 204.485 220.603 203.899 220.017L194.353 210.471ZM194.792 312.425L194.792 211.532L191.792 211.532L191.792 312.425L194.792 312.425Z",
    fill: "#41B6E6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M333.178 259.482L320.303 269.675L346.054 269.675L333.178 259.482Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 278.678,
    y: 269.675,
    width: 109,
    height: 43,
    rx: 4,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M296.341 297.675H305.953V294.831H299.329V284.373H296.341V297.675ZM307.609 297.675H316.879V294.903H310.597V292.365H316.429V289.611H310.597V287.145H316.897V284.373H307.609V297.675ZM327.921 284.373V292.149L321.279 284.373H319.263V297.675H322.197V289.971L328.695 297.675H330.837V284.373H327.921ZM339.906 297.873C342.264 297.873 344.352 296.901 345.972 295.281V289.683H339.888V292.239H343.272V293.769C342.57 294.453 341.31 295.029 339.96 295.029C337.548 295.029 335.964 293.211 335.964 290.997C335.964 288.729 337.638 287.001 339.978 287.001C341.31 287.001 342.516 287.541 343.398 288.369L345.306 286.209C344.154 285.039 342.228 284.139 339.996 284.139C336.036 284.139 332.922 286.983 332.922 291.033C332.922 294.975 335.82 297.873 339.906 297.873ZM350.473 287.235V297.675H353.461V287.235H357.205V284.373H346.711V287.235H350.473ZM358.867 297.675H361.837V292.437H367.021V297.675H370.009V284.373H367.021V289.575H361.837V284.373H358.867V297.675Z",
    fill: "#41B6E6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7927 259.482L35.9174 269.675L61.6681 269.675L48.7927 259.482Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.792725,
    y: 269.675,
    width: 96,
    height: 43,
    rx: 4,
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3867 297.675H24.0687L26.6607 289.395L29.2527 297.675H31.9347L36.2727 284.373H32.9967L30.5487 293.031L27.6507 284.373H25.6527L22.7907 293.031L20.3067 284.373H17.0307L21.3867 297.675ZM37.769 284.373V297.675H40.757V284.373H37.769ZM43.5698 297.675H48.7898C52.9118 297.675 55.3598 295.119 55.3598 291.033C55.3598 286.947 52.9658 284.373 48.8798 284.373H43.5698V297.675ZM46.5398 294.813V287.235H48.9158C51.1658 287.235 52.2818 288.981 52.2818 291.015C52.2818 293.049 51.1658 294.813 48.9158 294.813H46.5398ZM59.6798 287.235V297.675H62.6678V287.235H66.4118V284.373H55.9178V287.235H59.6798ZM68.0737 297.675H71.0437V292.437H76.2277V297.675H79.2157V284.373H76.2277V289.575H71.0437V284.373H68.0737V297.675Z",
    fill: "#41B6E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3764_8996",
    x1: 145.5,
    y1: 183.5,
    x2: 131.5,
    y2: 207.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79C71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#D1A478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A6845"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3764_8996",
    x1: 289,
    y1: 171.5,
    x2: 295,
    y2: 181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A67C51"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCementBagBig);
export default __webpack_public_path__ + "static/media/cement-bag--big.c9555b3fd463923ed73cb3ba3a2db2db.svg";
export { ForwardRef as ReactComponent };